<template>
  <div>
    <div v-if="selectedVideo" class="mb-3">
      <img :src="selectedVideo.thumbnail_url" class="h-100 w-25">
    </div>
    <v-select :options="videos" label="title" v-model="selectedVideo"></v-select>
  </div>
</template>

<script>
import find from 'lodash-es/find';

export default {
  name: 'CourseBuilderVideo',
  computed: {
    videos () {
      return this.$store.state.videos;
    },
    selectedVideo: {
      get () {
        return find(this.videos, {id: parseInt(this.value)});
      },
      set (val) {
        this.$emit('input', val.id);
      }
    }
  },
  props: ['value']
};
</script>

<style scoped>

</style>